import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles';
import withWidth, {isWidthUp} from "@material-ui/core/withWidth/withWidth";

const style = theme => ({
    gridWrapper: {
        height:'100%',
        minHeight:'0px'
    },
    paper: {
        height:'100%',
        overflow:'auto'
    }
});

function getSuitSymbols(theString) {
    let tempString = "";

    if(theString == "X") {
        return <Typography variant="body1" inline style={{color:"#000000"}}>X</Typography>
    }

    if(theString == "XX") {
        return <Typography variant="body1" inline style={{color:"#000000"}}>XX</Typography>
    }

    if(theString == "Pass") {
        return <Typography variant="body1" inline style={{color:"#000000"}}>Pass</Typography>
    }

    if((theString.length == 4) && (theString.substring(0, 2) == "Pass")) {
        return <Typography variant="body1" inline style={{color:"#000000"}}>Pass</Typography>
    }

    if(theString.length > 1) {
        tempString = theString.substring(1, 2);
        switch (tempString) {
            case "S":
                return (
                    <>
                        <Typography variant="body1" inline>{theString.substring(0, 1)}</Typography>
                        <Typography variant="body1" inline style={{color: "#000000"}}>&spades;</Typography>
                    </>
                );
            case "H":
                return (
                    <>
                        <Typography variant="body1" inline>{theString.substring(0, 1)}</Typography>
                        <Typography variant="body1" inline style={{color: "#F44336"}}>&hearts;</Typography>
                    </>
                );
            case "D":
                return (
                    <>
                        <Typography variant="body1" inline>{theString.substring(0, 1)}</Typography>
                        <Typography variant="body1" inline style={{color: "#F44336"}}>&diams;</Typography>
                    </>
                );
            case "C":
                return (
                    <>
                        <Typography variant="body1" inline>{theString.substring(0, 1)}</Typography>
                        <Typography variant="body1" inline style={{color: "#000000"}}>&clubs;</Typography>
                    </>
                );
            case "N":
                return (
                    <Typography variant="body1" inline>{theString.substring(0, 1) + "NT"}</Typography>
                );
        }
    }

    return (
        <Typography variant="body1" inline>{theString}</Typography>
    );
}

class Auction extends Component {
    render() {
        const { classes } = this.props;

        let tmpArray = [];

        if ((this.props.auctionArray instanceof Array) && this.props.auctionProgressPointer > 0) {

            let tableCellArray = [];
            let count = 0;
            for (let i=0; i < this.props.pbnDealer; i++) {
                tableCellArray[count++] = <TableCell align="center"> </TableCell>;
            }

            for (let i=0; i < this.props.auctionProgressPointer; i++) {
                tableCellArray[count++] = <TableCell align="center">{getSuitSymbols(this.props.auctionArray[i])} </TableCell>;
            }

            while (count%4 != 0) {
                tableCellArray[count++] = <TableCell align="center"> </TableCell>;
            }

            for (let i=0; i < count/4; i++) {
                tmpArray[i] = (
                    <TableRow key={i}>
                        {tableCellArray[i*4]}
                        {tableCellArray[i*4 + 1]}
                        {tableCellArray[i*4 + 2]}
                        {tableCellArray[i*4 + 3]}
                    </TableRow>
                );
            }
        }

        let auctionControl;
        if ('sm' === this.props.width) {
            auctionControl = (
                <Grid container direction={"column"} wrap={"nowrap"} justify={"space-evenly"}>
                    <Grid item container direction={"row"} wrap={"nowrap"} justify={"center"}>
                        <Button color={"primary"} size={"small"} variant={"outlined"} onClick={this.props.onAuctionPreviousClick}>{"<"}</Button>
                        <Button color={"primary"} size={"small"} variant={"outlined"} onClick={this.props.onAuctionNextClick}>{">"}</Button>
                    </Grid>
                    <Grid item container direction={"row"} wrap={"nowrap"} justify={"center"}>
                        <Button color={"secondary"} size={"small"} onClick={this.props.onAuctionHideClick}>Reset</Button>
                        <Button color={"primary"} size={"small"}  onClick={this.props.onAuctionShowClick}>Show</Button>
                    </Grid>
                </Grid>
            );
        } else {
            auctionControl = (
                <Grid container container direction={"row"} wrap={"nowrap"} justify={"space-evenly"}>
                    <Button color={"secondary"} size={"small"} onClick={this.props.onAuctionHideClick}>Reset</Button>
                    <Button color={"primary"} size={"small"} variant={"outlined"} onClick={this.props.onAuctionPreviousClick}>{"<"}</Button>
                    <Button color={"primary"} size={"small"} variant={"outlined"} onClick={this.props.onAuctionNextClick}>{">"}</Button>
                    <Button color={"primary"} size={"small"}  onClick={this.props.onAuctionShowClick}>Show</Button>
                </Grid>
            );
        }

        return (
            <Grid container className={classes.gridWrapper}  direction={"column"} wrap={"nowrap"}>
                <Paper className={classes.paper} elevation={0} >
                    <Table padding={"none"}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{width:'25%'}}><Typography variant="body1" inline>North</Typography></TableCell>
                                <TableCell align="center" style={{width:'25%'}}><Typography variant="body1" inline>East </Typography></TableCell>
                                <TableCell align="center" style={{width:'25%'}}><Typography variant="body1" inline>South</Typography></TableCell>
                                <TableCell align="center" style={{width:'25%'}}><Typography variant="body1" inline>West</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tmpArray}
                        </TableBody>
                    </Table>
                </Paper>
                {auctionControl}
            </Grid>
        );
    }
}

Auction.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.object,
    pbnDealer: PropTypes.number,
    auctionArray: PropTypes.arrayOf(PropTypes.string),
    auctionProgressPointer: PropTypes.number,
    onAuctionPreviousClick: PropTypes.func.isRequired,
    onAuctionNextClick: PropTypes.func.isRequired,
    onAuctionShowClick: PropTypes.func.isRequired,
    onAuctionHideClick: PropTypes.func.isRequired

}

export default withStyles(style)(withWidth()(Auction));